import React from 'react'
import IconButton from '@mui/material/IconButton'
import PersonIcon from '@mui/icons-material/Person'
import Typography from '@mui/material/Typography'
import Popover from '@mui/material/Popover'
import { useAuth0 } from '@auth0/auth0-react'
import Box from '@mui/material/Box'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { styled } from '@mui/material/styles'
import LogoutIcon from '@mui/icons-material/Logout'
import { useTranslation } from 'react-i18next'

const Logout = styled(Box)(({ theme: { transitions, spacing } }) => ({
  display: 'flex',
  padding: spacing(2),
  backgroundColor: '#F2F8FA',
  cursor: 'pointer',
  transition: transitions.create('background-color', {
    easing: transitions.easing.easeInOut,
    duration: transitions.duration.shorter
  }),
  '&:hover': {
    backgroundColor: '#F8FCFE'
  }
}))

const UserPopover: React.FC = () => {
  const { user, logout } = useAuth0()
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'user-popover' : undefined

  return (
    <>
      <IconButton onClick={handleClick}>
        <PersonIcon sx={{ color: 'common.white' }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Box sx={{ display: 'flex', py: 2, px: 3, minWidth: '400px' }}>
          <AccountCircleIcon sx={{ mr: 2 }} />
          <Box>
            <Typography>{user?.name ?? ''}</Typography>
          </Box>
        </Box>
        <Logout onClick={() => logout({ returnTo: `${window.location.origin}/vendors/login` })}>
          <LogoutIcon color="primary" />
          <Typography sx={{ ml: 1 }} color="primary">
            {t('sign-out')}
          </Typography>
        </Logout>
      </Popover>
    </>
  )
}

export default UserPopover
